import { memo } from 'react';
import { useParams } from 'react-router-dom';
import { ChemicalComponentList } from '@/admin-pages/Components';

export default memo(function PhysicalPropertyComponents() {
  const { orgId } = useParams<{ orgId: string }>();

  return (
    <ChemicalComponentList orgId={Number(orgId)} />
  );
});
